import React from 'react';
import { Link } from 'react-router-dom';

import SiteHeader from '../../components/siteChrome/SiteHeader';
import SiteFooter from '../../components/siteChrome/SiteFooter';
import { trackWhatsappClick } from '../../utils/analytics';
import { INSTAGRAM_URL, WHATSAPP_URL } from '../../utils/siteLinks';
import ContactForm from './components/ContactForm';
import './contactUs.css';

/** Contact page — source: mockup L933–1001. */
const ContactUs = (): React.JSX.Element => (
  <>
    <SiteHeader />
    <main id="main-content" role="main" tabIndex={-1}>
      {/* HERO */}
      <section className="oq-contact-hero">
        <div className="oq-contact-hero__inner">
          <div className="oq-contact-hero__kicker oq-bebas">GET IN TOUCH</div>
          <h1 className="oq-contact-hero__title oq-bebas">Let&apos;s get your club started</h1>
          <p className="oq-contact-hero__subtitle">
            Book a demo, ask a question, or just say hello. However you like to talk,
            we&apos;re here.
          </p>
        </div>
      </section>

      {/* FORM + CHANNELS */}
      <section className="oq-contact-body">
        <div className="oq-container oq-contact-body__inner">
          <div className="oq-contact-row">
            <div className="oq-contact-row__form">
              <div className="oq-contact-form">
                <ContactForm />
              </div>
            </div>

            <div className="oq-contact-row__channels">
              <a
                href={WHATSAPP_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="oq-contact-channel"
                onClick={() => trackWhatsappClick()}
              >
                <div className="oq-contact-channel__icon oq-contact-channel__icon--whatsapp">
                  <i className="mdi mdi-whatsapp" aria-hidden="true" />
                </div>
                <div className="oq-contact-channel__body">
                  <div className="oq-contact-channel__title oq-bebas">WhatsApp us</div>
                  <div className="oq-contact-channel__subtitle">
                    Quick questions, fast replies
                  </div>
                </div>
                <i className="mdi mdi-chevron-right oq-contact-channel__chevron" aria-hidden="true" />
              </a>

              <a
                href={INSTAGRAM_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="oq-contact-channel"
              >
                <div className="oq-contact-channel__icon oq-contact-channel__icon--instagram">
                  <i className="mdi mdi-instagram" aria-hidden="true" />
                </div>
                <div className="oq-contact-channel__body">
                  <div className="oq-contact-channel__title oq-bebas">See us on Instagram</div>
                  <div className="oq-contact-channel__subtitle">
                    @olympiq_app — clubs &amp; features
                  </div>
                </div>
                <i className="mdi mdi-chevron-right oq-contact-channel__chevron" aria-hidden="true" />
              </a>

              <div className="oq-contact-selfserve">
                <div className="oq-contact-selfserve__head">
                  <img src="/images/oq-avatar.png" alt="" className="oq-contact-selfserve__avatar" />
                  <div className="oq-bebas oq-contact-selfserve__title">Prefer to self-serve?</div>
                </div>
                <p className="oq-contact-selfserve__body">
                  Ask OQ, our AI assistant, in the help centre — it answers most questions
                  instantly.
                </p>
                <Link to="/help-centre" className="oq-contact-selfserve__cta">
                  Ask OQ
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
    <SiteFooter />
  </>
);

export default ContactUs;
